export default __webpack_public_path__ + "static/media/materialsPrep.9eaea8c7.svg";